import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useImportSeasonEntities = () => {
  const { sport, organizationId, seasonId } = useParams();
  const { formatMessage } = useIntl();
  const request = useApi();
  const notification = useNotification();
  const queryClient = useQueryClient();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (fileName: string) =>
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/entities/import`, {
        method: "POST",
        body: { fileName },
      }),
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        notification.success({
          message: formatMessage({ id: "seasonEntity.import.started" }),
          placement: "bottomRight",
        });

        await queryClient.invalidateQueries({ queryKey: ["seasonEntities", sport, organizationId, seasonId] });
      }
    },
  });
};
